import { apiRequestRaw } from "../http";

/**
 * Flat `{ISO-3166-1 alpha-2: weight}` from App Service (DAI-1168).
 * Serving order is the UI contract: weighted codes first, then weight-0 alphabetically.
 */
export type GeoReference = Record<string, number>;

/** GET /api/references/geo — certificate-edit GEO dictionary. */
export async function getGeoReference(): Promise<GeoReference> {
	return apiRequestRaw<GeoReference>({
		path: "/api/references/geo",
		method: "GET",
	});
}

/** Priority chips (weight > 0) in API order. */
export function priorityGeosFromReference(ref: GeoReference): string[] {
	return Object.entries(ref)
		.filter(([, weight]) => weight > 0)
		.map(([code]) => code.toUpperCase());
}

/** Rest of the catalog for "+ GEO" (weight === 0), API order. */
export function extraGeosFromReference(ref: GeoReference): string[] {
	return Object.entries(ref)
		.filter(([, weight]) => weight <= 0)
		.map(([code]) => code.toUpperCase());
}
